
import { StartSidebarComponent } from './start-sidebar/start-sidebar.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, Route } from '@angular/router';

/*const routes: Route[] = [{
  path: 'prof',
  component: StartSidebarComponent,
  children: [
    {path: '', component: ProfessorMenuComponent, outlet: 'menu'}
  ]
} ,
{
  path: 'crd',
  component: StartSidebarComponent,
  children: [
    {path: '', component: CoordinatorMenuComponent, outlet: 'menu'}
  ]
},
{
  path: '',
  component: StartSidebarComponent,
  children: [
    {path: '', component: ProfessorMenuComponent, outlet: 'menu'}
  ]
}
];
*/

const routes: Routes = [
 
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SidebarRoutingModule { }
